import { ResourceRequestApi } from "../DTO/ClientRequest/Resource";
import {
  isResourceResponseDTO,
  ResourceResponseApi,
} from "../DTO/ServerResponseType/Resource/Resource";
import { isResourceIdResponseDTO } from "../DTO/ServerResponseType/Resource/ResourceId";
import {
  isResourceWithContentResponseDTO,
  ResourceWithContentResponseApi,
} from "../DTO/ServerResponseType/Resource/ResourceWithContent";
import { ServerClient, serverOrigin } from "./Configs";
import {
  getTypeGuardedArrayVariableAsync,
  getTypeGuardedVariableAsync,
} from "./typeGuard";

class ResourceServerClient {
  private path = "/resource";

  sendToUpdateResourceAsync = async (
    resourceData: ResourceRequestApi
  ): Promise<null> => {
    await this.sendUpdatedResourceAsync(resourceData)
      .then(() => {
        alert("Ресурс успешно изменена.");
      })
      .catch((error) => {
        console.error("Ошибка:", error);
      });

    return null;
  };

  sendUpdatedResourceAsync = async (
    resourceData: ResourceRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/update/all";

    const formData = new FormData();
    formData.append(
      "resourceId",
      JSON.stringify({ resourceId: resourceData.resource.resourceId })
    );
    formData.append("resourceNewData", JSON.stringify(resourceData.resource));
    if (resourceData.resourceFile && resourceData.resourceFile.imageData)
      formData.append("resource", resourceData.resourceFile.imageData);

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: formData,
      credentials: "include",
    });

    return response;
  };

  sendToCreateResourceAsync = async (
    resourceData: ResourceRequestApi
  ): Promise<string | null> => {
    let resourceId = getTypeGuardedVariableAsync(
      this.sendNewResourceAsync(resourceData),
      isResourceIdResponseDTO
    )
      .then((resourceIdDTO) => {
        alert("Ресурс успешно создан.");
        let resourceId = resourceIdDTO.resourceId;
        return resourceId;
      })
      .catch((error) => {
        console.error("Ошибка:", error);
        return null;
      });

    return resourceId;
  };

  sendNewResourceAsync = async (
    resourceData: ResourceRequestApi
  ): Promise<unknown> => {
    let url: string = serverOrigin + this.path + "/create";

    const formData = new FormData();
    formData.append("resourceData", JSON.stringify(resourceData.resource));
    if (resourceData.resourceFile && resourceData.resourceFile.imageData)
      formData.append("resource", resourceData.resourceFile.imageData);

    let response = await ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: formData,
      credentials: "include",
    });

    return response;
  };

  sendToGetResourceWithContentByResourceIdAsync = async (
    resourceId: string
  ): Promise<ResourceWithContentResponseApi | never> => {
    let url: string =
      serverOrigin +
      this.path +
      "/show/one?resourceId=" +
      resourceId +
      "&withContent=true";

    let resource: ResourceWithContentResponseApi =
      await getTypeGuardedVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isResourceWithContentResponseDTO
      );

    return resource;
  };

  sendToGetAllResourcesAsync = async (): Promise<
    ResourceResponseApi[] | never
  > => {
    let url: string = serverOrigin + this.path + "/show/all";

    let resources: ResourceResponseApi[] =
      await getTypeGuardedArrayVariableAsync(
        ServerClient.sendRequestAsync({
          url: url,
          method: "GET",
          credentials: "include",
        }),
        isResourceResponseDTO
      );

    return resources;
  };

  async sendToDeleteResourceAsync(resourceId: string): Promise<unknown> {
    let url: string = serverOrigin + this.path + "/delete";

    let sendPromise = ServerClient.sendRequestAsync({
      url: url,
      method: "POST",
      body: JSON.stringify({ resourceId: resourceId }),
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    });

    return sendPromise.catch((error) => {
      console.error("Ошибка:", error);
    });
  }
}

let resourceServerClient = new ResourceServerClient();

export default resourceServerClient;
